/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */
import { TablesRes, UserInfo } from '../types.ds';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const getTableList = async (playerId: string | undefined) => {
  try {
    const response = await fetch(`${API_ENDPOINT}/post/getTables/${playerId == "" ? undefined : playerId}`);
    if (response.status === 200) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const res: TablesRes = await response.json();
      return res;
    }
    if (response.status === 404) {
      const res: TablesRes = await response.json();
      return res;
    }
  } catch (error: any) {
    throw new error('Failed to get table list.');
  }
};